import { render, staticRenderFns } from "./Quietanzianti.vue?vue&type=template&id=6f73f919&"
import script from "./Quietanzianti.vue?vue&type=script&lang=ts&"
export * from "./Quietanzianti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports